import * as React from 'react';
import { classes, st } from './IconTooltip.st.css';
import { CoreButtonNext as ButtonNext } from '../internal/WixUiCoreComponents/components/CoreButtonNext';
import { uid } from 'react-uid';
import { Tooltip } from '../Tooltip';
import { TooltipSkin } from '../Tooltip/types';
import { IconTooltipProps, IconTooltipDefaultProps } from './types';

/** An icon that shows a tooltip on focus and on hover. */
export class IconTooltip extends React.Component<IconTooltipProps> {
  static displayName = 'IconTooltip';
  static defaultProps: IconTooltipDefaultProps = {
    message: '',
    icon: undefined,
    tooltipId: undefined,
    tooltipSkin: TooltipSkin.Standard,
    showTooltip: false,
  };

  render() {
    const generatedTooltipId = `${uid(IconTooltip.displayName)}-${Math.random()
      .toString(36)
      .substring(2)}`;

    const {
      message,
      icon,
      tooltipId = generatedTooltipId,
      tooltipSkin,
      showTooltip,
      onClickOutside,
      onEscape,
      tooltipProps,
      'data-hook': dataHook,
      className,
      ...rest
    } = this.props;
    const content = <span id={tooltipId}>{message}</span>;

    return (
      <Tooltip
        className={st(classes.root, {}, className)}
        data-hook={dataHook}
        aria-live="polite"
        disabled={!showTooltip}
        content={content}
        appendTo="scrollParent"
        skin={tooltipSkin}
        shown={showTooltip}
        onClickOutside={onClickOutside}
        disableClickOutsideWhenClosed
        onEscPress={onEscape}
        {...tooltipProps}
      >
        <>
          <ButtonNext
            className={classes.button}
            aria-pressed={showTooltip}
            aria-labelledby={tooltipId}
            {...rest}
          >
            <div className={classes.icon}>{icon}</div>
          </ButtonNext>
          {/*
            This is a hack to have the aria-labelledby always point to an element in the dom.
            We'll need to change the Tooltip's behavior to always be rendered in the DOM, and showing/hiding with css only
          */}
          {!showTooltip ? (
            <span id={tooltipId} className={classes.tooltipMessage}>
              {message}
            </span>
          ) : null}
        </>
      </Tooltip>
    );
  }
}
